import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createQuestionStart,
  editQuestionStart,
  deleteQuestionStart,
  createQuestionImageStart,
  editQuestionImageStart,
  createBulkQuestionStart,
} from "../../redux/questions/reducer";
import {
  selectIsEditingQuestion,
  selectIsDeletingQuestion,
} from "../../redux/questions/selectors";

const useQuestionEditor = () => {
  const dispatch = useDispatch();
  const isEditing = useSelector(selectIsEditingQuestion);
  const isDeleting = useSelector(selectIsDeletingQuestion);

  const createQuestion = useCallback(
    (data) => {
      dispatch(createQuestionStart(data));
    },
    [dispatch]
  );

  const editQuestion = useCallback(
    (data) => {
      dispatch(editQuestionStart(data));
    },
    [dispatch]
  );

  const deleteQuestion = useCallback(
    (data) => {
      dispatch(deleteQuestionStart(data));
    },
    [dispatch]
  );

  const createQuestionWithImage = useCallback(
    (data) => {
      dispatch(createQuestionImageStart(data));
    },
    [dispatch]
  );

  const editQuestionWithImage = useCallback(
    (data) => {
      dispatch(editQuestionImageStart(data));
    },
    [dispatch]
  );

  const uploadBulkQuestions = useCallback(
    (data) => {
      dispatch(createBulkQuestionStart(data));
    },
    [dispatch]
  );

  return {
    isEditing,
    isDeleting,
    createQuestion,
    deleteQuestion,
    editQuestion,
    createQuestionWithImage,
    editQuestionWithImage,
    uploadBulkQuestions,
  };
};

export default useQuestionEditor;
